import {ModuleWithProviders, NgModule} from '@angular/core';
import {GroupsListingComponent} from './groups-listing/groups-listing.component';
import {IsUserLogged} from '../../../guards/is-user-logged.class';
import {RouterModule, Routes} from '@angular/router';
import {GroupsManagementComponent} from './groups-management.component';
import {FuseSharedModule} from '@fuse/shared.module';
import {FuseGroupsFormDialogComponent} from '@modules/groups-management/core/groups-listing/groups-form/groups-form.component';
import {FuseGroupsMainSidenavComponent} from '@modules/groups-management/core/groups-listing/sidenavs/main/main.component';
import {FuseGroupsListComponent} from './groups-listing/groups-list/groups-list.component';
import {LearnerComponent} from './learner/learner.component';
import {GroupComponent} from './group/group.component';
import {WorkgroupComponent} from './workgroup/workgroup.component';
import {TrainerComponent} from './trainer/trainer.component';
import {SharedModule} from 'shared/shared.module';
import {InstitutionGroupComponent} from './institution-group/institution-group.component';
import {DataEntity} from 'octopus-connect';
import {JoinGroupComponent} from './join-group/join-group.component';
import {GroupsCustomActionComponent} from './groups-listing/groups-custom-action/groups-custom-action.component';
import {UsersImportComponent} from './users-import/users-import.component';
import {TwoStepsSelectionModule} from 'fuse-core/components/two-steps-selection/two-steps-selection.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {GroupsInlineModalComponent} from './groups-listing/groups-inline-modal/groups-inline-modal.component';
import {CreateGroupNewsComponent} from './onboarding/components/create-group-news/create-group-news.component';
import {CreateLeanerNewsComponent} from './onboarding/components/create-leaner-news/create-leaner-news.component';
import {IsCollapsibleFieldDirective} from './groups-listing/directives/is-collapsible-field.directive';
import {ForbiddenPathInterface, IsUserAuthorisedByRoleGuard} from '../../../guards/is-user-authorised-by-role.guard';
import {AlertLearnersComeFromSsoNewsComponent} from './onboarding/components/alert-learners-come-from-sso-news/alert-learners-come-from-sso-news.component';
import {
    AlertTeachersComeFromSsoNewsComponent
} from '@modules/groups-management/core/onboarding/components/alert-teachers-come-from-sso-news/alert-teachers-come-from-sso-news.component';
import {TabSelectorComponent} from '@modules/groups-management/core/institution-management/tab-selector/tab-selector.component';
import {MultiTabsViewComponent} from '@modules/groups-management/core/institution-management/multi-tabs-view/multi-tabs-view.component';
import {IsAtLeastTrainerGuard} from '../../../guards/is-at-least-trainer-guard.service';
import {InstitutionManagementRoutes} from '@modules/groups-management/core/institution-management/institution-management.routes';
import {InstitutionUsersComponent} from '@modules/groups-management/core/institution-management/institution-users/institution-users.component';
import {InstitutionInformationComponent} from '@modules/groups-management/core/institution-management/institution-information/institution-information.component';
import {EditUserComponent} from './institution-management/institution-users/edit-user/edit-user.component';
import {LicenseManagementComponent} from './license-management/license-management/license-management.component';
import {EditUserAndLicenseComponent} from './license-management/edit-user-and-license/edit-user-and-license.component';
import {IsUserCanEditLicensesGuard} from '@modules/groups-management/core/guards/is-user-can-edit-licences.guard';
import {GlobalAsyncRules} from 'shared/models/';
import {combineLatest, Observable, Subject} from 'rxjs';
import {IsUserCanAccessUsersAdminFeaturesGuard} from '@modules/groups-management/core/guards/is-user-can-acces-users-management.guard';
import {ChooseGroupComponent} from '@modules/groups-management/core/choose-group/choose-group.component';
import {CreateTeacherNewsComponent} from './onboarding/components/create-teacher-news/create-teacher-news.component';
import { AssociationLearnerToGroupComponent } from './onboarding/components/association-learner-to-group/association-learner-to-group.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatAutocomplete, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';
import {MatCardModule} from '@angular/material/card';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {AriaTitleDirective} from 'fuse-core/directives/aria-title.directive';
import {FocusBoundaryDirective} from 'fuse-core/directives/focus-boundary.directive';
import {ColorPickerComponent} from '@modules/groups-management/core/groups-listing/groups-form/color-picker.component';


const routes: Routes = [
    {
        path: '',
        canActivate: [IsUserLogged, IsUserAuthorisedByRoleGuard],
        children: [
            {
                path: 'list',
                component: GroupsManagementComponent,
                children: [
                    {
                        path: 'learners',
                        component: LearnerComponent,
                        data: {
                            icon: 'student_add'
                        },
                    },
                    {
                        path: 'groups',
                        component: GroupComponent,
                        data: {
                            icon: 'class_add'
                        },
                    },
                    {
                        path: 'workgroups',
                        component: WorkgroupComponent,
                        data: {
                            icon: 'workgroup_add'
                        },
                    },
                    {
                        path: 'trainers',
                        component: TrainerComponent,
                        data: {
                            icon: 'trainer_add'
                        }
                    },
                    {
                        path: 'institutions',
                        component: InstitutionGroupComponent,
                        data: {
                            icon: 'institution_add'
                        }
                    },
                    {
                        path: '**',
                        pathMatch: 'full',
                        redirectTo: 'learners'
                    },
                ]
            },
            {
                path: '**',
                pathMatch: 'full',
                redirectTo: 'list'
            }
        ]
    },
    {
        path: 'institution',
        component: GroupsManagementComponent,
        children: [
            {
                path: 'multi',
                component: MultiTabsViewComponent,
                children: [
                    {path: InstitutionManagementRoutes.Users, component: InstitutionUsersComponent, canActivate: [IsUserCanAccessUsersAdminFeaturesGuard]},
                    {path: InstitutionManagementRoutes.Information, component: InstitutionInformationComponent},
                    {
                        path: '**',
                        redirectTo: InstitutionManagementRoutes.Users,
                        pathMatch: 'full'
                    }
                ],
                canActivate: [IsAtLeastTrainerGuard]
            }
        ],
    },
    {
        path: 'license-management',
        canActivate: [IsUserCanEditLicensesGuard],
        component: LicenseManagementComponent
    }
];

@NgModule({
    imports: [
        FuseSharedModule,
        SharedModule,
        RouterModule.forChild(routes),
        TwoStepsSelectionModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatAutocomplete,
        MatAutocompleteTrigger,
        MatDatepicker,
        MatDatepickerToggle,
        MatDatepickerInput,
        MatCardModule,
        MatSlideToggle,
        AriaTitleDirective,
        FocusBoundaryDirective,
        ColorPickerComponent,
    ],
    declarations: [
        GroupsListingComponent,
        GroupsManagementComponent,
        FuseGroupsFormDialogComponent,
        FuseGroupsMainSidenavComponent,
        FuseGroupsListComponent,
        LearnerComponent,
        GroupComponent,
        WorkgroupComponent,
        TrainerComponent,
        InstitutionGroupComponent,
        JoinGroupComponent,
        GroupsCustomActionComponent,
        UsersImportComponent,
        GroupsInlineModalComponent,
        CreateGroupNewsComponent,
        CreateLeanerNewsComponent,
        IsCollapsibleFieldDirective,
        AlertLearnersComeFromSsoNewsComponent,
        AlertTeachersComeFromSsoNewsComponent,
        TabSelectorComponent,
        MultiTabsViewComponent,
        InstitutionUsersComponent,
        InstitutionInformationComponent,
        EditUserComponent,
        LicenseManagementComponent,
        EditUserAndLicenseComponent,
        ChooseGroupComponent,
        CreateTeacherNewsComponent,
        AssociationLearnerToGroupComponent
    ],
    providers: [],
})
export class GroupsManagementModule {


    // Constructor logic moved to GroupsManagementInitializerService
    constructor() {}

    static forRoot(): ModuleWithProviders<GroupsManagementModule> {

        return {
            ngModule: GroupsManagementModule,
            providers: [] // Services are now provided in root
        };
    }

    // Methods postLogout, getForbiddenPathObject, postAuthentication moved to GroupsManagementInitializerService
}